/**
 * #4251 — conversões da data de expiração do informativo.
 *
 * Duas direções, e as duas importam:
 *
 * 1. `paraCampoDeData` — o que veio da API (ISO, com fuso) para o formato que o
 *    input datetime-local aceita ("YYYY-MM-DDTHH:mm", em horário LOCAL). Sem
 *    isso o campo abre vazio ao editar, e salvar apagaria a data existente.
 *
 * 2. `paraInstanteAbsoluto` — o valor digitado (horário local, SEM fuso) para
 *    ISO. A conversão precisa acontecer aqui, no navegador: ele é quem conhece
 *    o fuso de quem preencheu. Feita no backend, valeria o fuso do SERVIDOR
 *    (UTC num container) e a expiração ficaria deslocada. A coluna no banco é
 *    TIMESTAMP WITH TIME ZONE, que guarda instante absoluto.
 *
 * Puras de propósito: dá para testar as duas pontas sem montar o modal.
 */

const pad = (n) => String(n).padStart(2, "0");

export const paraCampoDeData = (valor) => {
  if (!valor) return "";
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

export const paraInstanteAbsoluto = (valor) => {
  if (!valor) return null;
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};
